export default __webpack_public_path__ + "static/media/image16.31a451b2.jpeg";